var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-group-main" }, [
    _c(
      "div",
      { staticClass: "yxtbiz-group-main-title" },
      [
        _c("Title", {
          attrs: { title: _vm.$t("pc_biz_group_edit" /* 编辑分组 */) },
          on: { close: _vm.onCancel },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "yxtbiz-group-main-content" }, [
      _c(
        "div",
        { staticClass: "yxtbiz-group-main-content-left" },
        [
          _c("Group", {
            attrs: {
              "member-list": _vm.memberList,
              id: _vm.groupId,
              "group-list": _vm.groupList,
              dragging: _vm.dragging,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "yxtbiz-group-main-content-right" },
        [
          _c("Member", {
            attrs: {
              "member-list": _vm.currentMember,
              "group-id": _vm.groupId,
              action: _vm.action,
            },
          }),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "yxtbiz-group-main-footer" },
      [
        _c("Handler", {
          attrs: { action: _vm.action, "group-list": _vm.groupList },
        }),
        _c("Submit", { on: { cancel: _vm.onCancel, submit: _vm.onSubmit } }),
      ],
      1
    ),
    _c("div", { staticClass: "yxtbiz-group-main-drag" }, [
      _c(
        "span",
        { staticClass: "yxtbiz-group-main-drag__name" },
        [
          _c("yxtbiz-user-name", {
            attrs: { name: _vm.dragUser.fullname || "--" },
          }),
          _vm._v("\n          ("),
          _c("yxtbiz-dept-name", {
            attrs: { name: _vm.dragUser.deptName || "--" },
          }),
          _vm._v(")\n        "),
        ],
        1
      ),
      _vm.showBadge
        ? _c("span", { staticClass: "yxtbiz-group-main-drag__badge" }, [
            _vm._v(
              _vm._s(
                _vm.selectedUserIds.value.length > 100
                  ? "99+"
                  : _vm.selectedUserIds.value.length
              )
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }